import * as PIXI from "pixi.js";
import { convertSize } from "../utils";
import SpriteGenerator from "../generators/SpriteGenerator";
import Text from "./Text";

export function loadPreludeScence(
  time,
  { texture, stage, renderer, resources }
) {
  const preludeScence = new PIXI.Container();
  preludeScence.x = 0;
  preludeScence.y = 0;

  preludeScence.width = renderer.width;
  preludeScence.height = renderer.height;

  const { width, height } = renderer.screen;

  const container = new PIXI.Container();

  const fontStyles = {
    fontFamily:
      "-apple-system, system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
    fontWeight: "bold",
    fontSize: convertSize(25, window.innerWidth), // 30
    lineHeight: convertSize(35, window.innerWidth) // 44
  };
  const introTexts = [
    Text("左右移动篮子", {
      ...fontStyles
    }),
    Text("接住红包", {
      ...fontStyles
    })
  ];

  let introTextsHeight = 0;
  introTexts.forEach((t, i) => {
    t.x = width / 2 - t.width / 2;
    t.y = i * t.height;
    introTextsHeight += t.height;
    // t.anchor.set(0.5);
    // t.width = renderer.width;
  });

  const countbgLayout = {
    width: convertSize(110, window.innerWidth),
    height: convertSize(110, window.innerWidth)
  };
  const countBackground = SpriteGenerator({
    ...countbgLayout,
    texture
  });

  const countOffsetY = introTextsHeight + convertSize(20, window.innerWidth);

  countBackground.x = width / 2 - countBackground.width / 2;
  countBackground.y = countOffsetY - convertSize(4, window.innerWidth);

  const countText = Text(time, {
    fontWeight: 500,
    fontSize: convertSize(60, window.innerWidth), //80
    lineHeight: convertSize(66.5, window.innerWidth), //88.5
    fill: 0x864529
  });

  countText.anchor.set(0.5);
  countText.x = width / 2;
  countText.y = countOffsetY + convertSize(50, window.innerWidth);

  container.addChild(...introTexts, countBackground, countText);

  container.y =
    height / 2 - container.height / 2 - convertSize(20, window.innerWidth);

  preludeScence.addChild(container);

  stage.addChild(preludeScence);

  return { preludeScence, countText };
}
